export default "__VITE_ASSET__CjkOQF2Q__"